// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React from "react";
import { Formik, Form, Field } from "formik";
import TextField from "@material-ui/core/TextField";
//import axios from "axios";
import * as Yup from "yup";
import {
  Input,
 
} from "../../../../../../_metronic/_partials/controls";


// Validation schema
const GuiConfEditSchema = Yup.object().shape({
  confTitle: Yup.string().required("Name is required"),
});

//const PageUrl = `${process.env.REACT_APP_API_URL}/api/guide`;

export function GuiConfEditForm({ guiConf, btnRef, saveGuiConf }) {
  // const [menuForDropdown, setMenuForDropdown] = useState([]);

  // useEffect(() => {
  //   const getInnerPagesWithAxios = async () => {
  //     const response = await axios.get(PageUrl);
  //     setMenuForDropdown(response.data);
  //   };
  //   getInnerPagesWithAxios();
  // }, [setMenuForDropdown]);

  const getFieldCSSClasses = (touched, errors) => {
    const classes = ["form-control"];
    if (touched && errors) {
      classes.push("is-invalid");
    }

    if (touched && !errors) {
      classes.push("is-valid");
    }

    return classes.join(" ");
  };
  const toBase64 = (uplaodFile) =>
    new Promise((resolve, reject) => {
      if (uplaodFile && uplaodFile !== "" && uplaodFile !== " ") {
        const reader = new FileReader();
        reader.readAsDataURL(uplaodFile);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      } else {
        resolve("");
      }
    });
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={guiConf}
        validationSchema={GuiConfEditSchema}
        onSubmit={(values) => {
          try {
            values.guideId = parseInt(values.guideId);
          }catch {}
          saveGuiConf(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, touched, errors }) => (
          <>
            <Form className="form form-label-right">
              
              <div className="form-group">
              Guide Id: {guiConf.guideId}
                {/* <Field
                  name="guideId"
                  component={Select}
                  placeholder="Guide Name"
                  label="Guide Name"
                  children={
                    menuForDropdown ? (
                      <>
                        <option value="0">None</option>
                        {menuForDropdown
                          .filter((menu) => menu.isActive)
                          .map((menu, index) => {
                            return (
                              <option key={index} value={menu.guideId}>
                                {menu.guideName}
                              </option>
                            );
                          })}
                      </>
                    ) : (
                      <option value="0">None</option>
                    )
                  }
                /> */}
              </div>
              <div className="form-group">
                <Field
                  name="confTitle"
                  component={Input}
                  placeholder="Conference Title"
                  label="Conference Title"
                />
              </div>
              <div className="form-group">
                <Field
                  name="category"
                  component={Input}
                  placeholder="Category"
                  label="Category"
                />
              </div>

              <div className="form-group">
                <TextField
                  id="date"
                  label="Held Date"
                  type="date"
                  name="heldDate"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setFieldValue("heldDate", e.target.value);
                  }}
                />
              </div>



              <div className="form-group">
                <Field
                  name="location"
                  component={Input}
                  placeholder="Location"
                  label="Location"
                />
              </div>
              <div className="form-group">
                <Field
                  name="remark"
                  component={Input}
                  placeholder="Remark"
                  label="Remark"
                />
              </div>
              <div className="form-group">
                <Field
                  name="link"
                  component={Input}
                  placeholder="Link"
                  label="Link"
                />
              </div>
             
              <div className="form-group">
                <label>Select Upload File</label>
                <input
                  className={getFieldCSSClasses(
                    touched["uplaodFile"],
                    errors["uplaodFile"]
                  )}
                  name="uplaodFile"
                  placeholder="Upload File"
                  label="Upload File"
                  type="file"
                  onChange={async (e) => {
                    setFieldValue(
                      "uplaodFile",
                      await toBase64(e.target.files[0])
                    );
                  }}
                  accept="file"
                />
              </div>
             
              <button
                type="submit"
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}
              ></button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
